import api from "./api";

export async function getQgbtLastRecord(usinaId) {
    const res = await api.get(`Qgbt/usina/${usinaId}/getAllLastData`);
    return res.data;
}
